import { getSupportedPostflopStack } from '../../utils/postflopStacks';
import isResultsStatPositionAvailable from './availability';
import {
  getCompatibleResultsSelection,
  getResultsBasePositionOptions,
  headsUpResultsPositionOptions,
  resultsPositionOptions,
  getResultsPositionTypeOptions,
  getResultsPreviousActionOptions,
  resultsPfrTypeOptions,
  resultsPlayerPositionOptions,
} from '../Postflop/resultsPositionOptions';

export const defaultResultsFilters = {
  tableSize: '6max',
  stackSize: '100bb',
  positionType: 'SRP',
  pfrType: 'pfr_ip',
  playerPosition: 'ip',
  position: 'EPvsBB_check',
};

// Normalize the entire dependent selection before displaying it or making a
// request. This avoids fetching a stale spot during table/stack/variant changes.
export const resolveResultsFilters = (filters = defaultResultsFilters, isPlo5 = false, boardType = '', handType = '') => {
  const tableSize = filters.tableSize === 'HU' ? 'HU' : '6max';
  const stackSize = getSupportedPostflopStack(filters.stackSize, isPlo5, tableSize);
  const positionTypeOptions = getResultsPositionTypeOptions(stackSize.value, tableSize, isPlo5);
  const positionType = positionTypeOptions.find((option) => option.value === filters.positionType)
    || positionTypeOptions[0];
  const isAvailable = (option, pot = positionType.value) => isResultsStatPositionAvailable(
    isPlo5, tableSize, stackSize.value, pot, option.value, boardType, handType,
  );

  const categoryOptions = tableSize === 'HU' ? headsUpResultsPositionOptions : resultsPositionOptions;

  const selection = getCompatibleResultsSelection(
    positionType,
    { value: filters.pfrType },
    { value: filters.playerPosition },
    isAvailable,
    positionTypeOptions,
    categoryOptions,
  );
  const { pfrType, playerPosition } = selection;
  const getAvailableOptions = (pfr, player) => (
    categoryOptions[positionType.value]?.[pfr]?.[player] || []
  ).filter((option) => isAvailable(option));
  const positionOptions = getAvailableOptions(pfrType.value, playerPosition.value);
  const position = positionOptions.find((option) => option.value === filters.position)
    || selection.position;
  const basePositionOptions = getResultsBasePositionOptions(
    positionType.value, pfrType.value, playerPosition.value, categoryOptions,
  ).filter((option) => positionOptions.some((item) => item.value.split('_')[0] === option.value));
  const previousActionOptions = getResultsPreviousActionOptions(
    positionType.value, pfrType.value, playerPosition.value, position.value.split('_')[0], categoryOptions,
  ).filter((option) => isAvailable(option));

  return {
    tableSize,
    stackSize,
    positionType,
    positionTypeOptions,
    pfrType,
    playerPosition,
    position,
    positionOptions,
    basePositionOptions,
    previousActionOptions,
    pfrTypeOptions: resultsPfrTypeOptions.filter((pfr) => resultsPlayerPositionOptions.some(
      (player) => getAvailableOptions(pfr.value, player.value).length > 0,
    )),
    playerPositionOptions: resultsPlayerPositionOptions.filter(
      (player) => getAvailableOptions(pfrType.value, player.value).length > 0,
    ),
  };
};

export const getResultsFilterValues = (selection) => ({
  tableSize: selection.tableSize,
  stackSize: selection.stackSize.value,
  positionType: selection.positionType.value,
  pfrType: selection.pfrType.value,
  playerPosition: selection.playerPosition.value,
  position: selection.position.value,
});
